function getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}
export const randomColor = () => {
    const colors = ['salmon', 'red', 'coral', 'tomato', 'gold', 'orange'];
    return colors[getRandomInt(0, colors.length - 1)]


};